import { render } from "./ProfileCircle.vue?vue&type=template&id=6b3c79a4&scoped=true"
import script from "./ProfileCircle.vue?vue&type=script&lang=js"
export * from "./ProfileCircle.vue?vue&type=script&lang=js"

import "./ProfileCircle.vue?vue&type=style&index=0&id=6b3c79a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3c79a4"]])

export default __exports__